import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deadlineChange } from '../../actions';
import { DeadlineDropdown as DeadlineDropdownComponent } from '../../components/DeadlineDropdown';
import { getDeadline, getDeadlineVariantsForSelect } from '../../selectors';
import { DEFAULT_DEADLINE_VALUE } from '../../reducers/filter';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';

export function DeadlineDropdown() {
  const dispatch: TThunkDispatch = useDispatch();
  const deadlineOptions = useSelector(getDeadlineVariantsForSelect);
  const deadline = useSelector(getDeadline);

  const handleDeadlineChange = React.useCallback(
    (value: number) => {
      dispatch(deadlineChange(value));
      setQueryParameter('deadline', value);
    },
    [dispatch],
  );

  return (
    <DeadlineDropdownComponent
      options={deadlineOptions}
      selectedDeadline={deadline || DEFAULT_DEADLINE_VALUE}
      onChange={handleDeadlineChange}
    />
  );
}
